import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const quickLinks = [
    { path: '/homepage', label: 'Beranda' },
    { path: '/motor-honda', label: 'Motor Honda' },
    { path: '/credit-simulation', label: 'Simulasi Kredit' },
    { path: '/service-booking', label: 'Booking Service' },
  ];

  const productLinks = [
    { path: '/motor-honda', label: 'Motor Matic' },
    { path: '/motor-honda', label: 'Motor Sport' },
    { path: '/motor-honda', label: 'Motor Bebek' },
    { path: '/parts-and-accessories', label: 'Suku Cadang' },
  ];

  const serviceLinks = [
    { path: '/service-booking', label: 'Service Berkala' },
    { path: '/service-booking', label: 'Service Darurat' },
    { path: '/credit-simulation', label: 'Pembiayaan' },
    { path: '/contact', label: 'Hubungi Kami' },
  ];

 const socialLinks = [
    { 
      name: 'Instagram', 
      img : '/assets/logo/instagram.png', 
      url: 'https://www.instagram.com/hondaberdikaripamulang'
    },
    { 
      name: 'TikTok', 
      img : '/assets/logo/tiktok.png',
      url: 'https://www.tiktok.com/@berdikarimotor4'
    },
  ];


  const contactInfo = [
    {
      icon: 'MapPin',
      title: 'Alamat',
      content: 'Jl. Raya Pamulang No. 123, Tangerang Selatan, Banten 15417',
    },
    {
      icon: 'Phone',
      title: 'Telepon',
      content: '+62 812-3456-7890',
      link: 'tel:+6281234567890',
    },
    {
      icon: 'Mail',
      title: 'Email',
      content: 'info@hondapamulang.co.id',
      link: 'mailto:info@hondapamulang.co.id',
    },
    {
      icon: 'Clock',
      title: 'Jam Operasional',
      content: 'Senin - Sabtu: 08:00 - 17:00 WIB',
    },
  ];

  const certifications = [
    { name: 'Dealer Resmi Honda', icon: 'Award' },
    { name: 'ISO 9001:2015', icon: 'Shield' },
    { name: 'Layanan Terpercaya', icon: 'CheckCircle' },
  ];

  return (
    <footer className="bg-secondary text-secondary-foreground">
      <div className="container mx-auto px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="space-y-6">
            <Link to="/homepage" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
              <div className="flex items-center justify-center">
                <img src="/assets/logo/logoHondaWhite.webp" alt="Honda Pamulang" className="h-14 w-auto object-contain"/>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-heading font-bold leading-tight">
                  Honda Berdikari 
                </span>
                <span className="text-sm text-muted-foreground font-medium">
                  Dealer Resmi
                </span>
              </div>
            </Link>

            <p className="text-sm text-muted-foreground leading-relaxed">
              Dealer resmi Honda terpercaya di Pamulang, Tangerang Selatan. 
              Menyediakan motor Honda berkualitas dengan layanan purna jual terbaik.
            </p>

            <div className="flex items-center space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-card hover:bg-primary flex items-center justify-center transition-all"
                >
                  <img
                    src={social.img}
                    alt={social.name}
                    className="h-8 w-8 object-contain"
                  />
                </a>
              ))}
            </div>

            <div className="flex flex-wrap gap-3">
              {certifications?.map((cert) => (
                <div
                  key={cert?.name}
                  className="flex items-center space-x-2 px-3 py-2 bg-card rounded-lg"
                >
                  <Icon name={cert?.icon} size={16} color="var(--color-primary)" />
                  <span className="text-xs font-medium text-foreground">{cert?.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold mb-4 text-primary">
              Tautan Cepat
            </h3>
            <ul className="space-y-3">
              {quickLinks?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 flex items-center space-x-2 group"
                  >
                    <Icon 
                      name="ChevronRight" 
                      size={16} 
                      className="opacity-0 group-hover:opacity-100 transition-opacity" 
                    />
                    <span>{link?.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold mb-4 text-primary">
              Produk & Layanan
            </h3>
            <ul className="space-y-3 mb-6">
              {productLinks?.map((link) => (
                <li key={link?.path + link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 flex items-center space-x-2 group"
                  >
                    <Icon 
                      name="ChevronRight" 
                      size={16} 
                      className="opacity-0 group-hover:opacity-100 transition-opacity" 
                    />
                    <span>{link?.label}</span>
                  </Link>
                </li>
              ))}
            </ul>

            <h3 className="text-lg font-heading font-bold mb-4 text-primary">
              Layanan
            </h3>
            <ul className="space-y-3">
              {serviceLinks?.map((link) => (
                <li key={link?.path + link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 flex items-center space-x-2 group"
                  >
                    <Icon 
                      name="ChevronRight" 
                      size={16} 
                      className="opacity-0 group-hover:opacity-100 transition-opacity" 
                    />
                    <span>{link?.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold mb-4 text-primary">
              Hubungi Kami
            </h3>
            <ul className="space-y-4">
              {contactInfo?.map((info) => (
                <li key={info?.title} className="flex items-start space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-card flex items-center justify-center flex-shrink-0">
                    <Icon name={info?.icon} size={18} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs font-medium text-muted-foreground mb-1">
                      {info?.title}
                    </p>
                    {info?.link ? (
                      <a
                        href={info?.link}
                        className="text-sm text-secondary-foreground hover:text-primary transition-colors"
                      >
                        {info?.content}
                      </a>
                    ) : (
                      <p className="text-sm text-secondary-foreground">
                        {info?.content}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-6 p-4 bg-card rounded-lg">
              <p className="text-sm font-heading font-semibold text-foreground mb-2">
                Butuh Bantuan?
              </p>
              <a
                href="https://wa.me/6288293642972"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-sm text-primary hover:text-accent transition-colors"
              >
                <Icon name="MessageCircle" size={18} />
                <span className="font-medium">Chat WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} Honda Pamulang. Semua hak dilindungi undang-undang.
            </p>

            <div className="flex items-center space-x-6">
              <Link
                to="/privacy-policy"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Kebijakan Privasi
              </Link>
              <Link
                to="/terms-of-service"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Syarat & Ketentuan
              </Link>
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-xs text-muted-foreground">
              Honda Pamulang adalah dealer resmi PT Astra Honda Motor. 
              Semua merek dagang dan logo adalah milik dari pemiliknya masing-masing.
            </p>
          </div>
        </div>
      </div>
      <div className="fixed bottom-6 right-6 z-40 lg:hidden">
        <a
          href="https://wa.me/6288293642972"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-primary rounded-full flex items-center justify-center shadow-honda-glow animate-pulse-slow hover:scale-110 transition-transform"
          aria-label="WhatsApp Consultation"
        >
          <Icon name="MessageCircle" size={28} color="white" strokeWidth={2} />
        </a>
      </div>
    </footer>
  );
};

export default Footer;